import APIInstance from "@/utils/apiConfig";
import { AxiosResponse } from "axios";
import {
  AuthorizationItem,
  AuthorizeForm,
  BulkAuthorizeRequest,
  BulkMyApprovalRequest,
  FormApprove,
  FormReject,
  FormRequest,
  RequestItem,
} from "@/models/request";

export const requestApi = {
  getMyRequest: async (): Promise<AxiosResponse<RequestItem[]>> => {
    return APIInstance.get("/myrequest");
  },
  getList: async (): Promise<AxiosResponse<RequestItem[]>> => {
    return APIInstance.get("/request");
  },
  createRequest: async (data: FormRequest) => {
    return APIInstance.post("/createrequest", data);
  },
  approveRequest: async (data: FormApprove) => {
    return APIInstance.post("/approverequest", data);
  },
  rejectRequest: async (data: FormReject) => {
    return APIInstance.post("/rejectrequest", data);
  },
  getListAuthorization: async (): Promise<Partial<AxiosResponse<AuthorizationItem[]>>> => {
    return APIInstance.get("/authorizerequest");
  },
  approveAuthorization: async (data: AuthorizeForm) => {
    return APIInstance.post("/approveauthorizerequest", data);
  },
  rejectAuthorization: async (data: AuthorizeForm) => {
    return APIInstance.post("/rejectauthorizerequest", data);
  },
  bulkapproverequest: async (request: BulkMyApprovalRequest) => {
    return APIInstance.post("/bulkapproverequest", request);
  },
  bulkrejectrequest: async (request: BulkMyApprovalRequest) => {
    return APIInstance.post("/bulkrejectrequest", request);
  },
  bulkapproveauthorizerequest: async (request: BulkAuthorizeRequest) => {
    return APIInstance.post("/bulkapproveauthorizerequest", request);
  },
  bulkrejectauthorizerequest: async (request: BulkAuthorizeRequest) => {
    return APIInstance.post("/bulkrejectauthorizerequest", request);
  },
  retractrequest: async (id: number | string) => {
    return APIInstance.post(`/retract/${id}`);
  },
};
